var _defs, _circle, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanDob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_169_2",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1660",
    width: 103.131,
    height: 81.219,
    x: 10.935,
    y: 21.891,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#fff;opacity:.2}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_324",
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#0663e2",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(74.99 1.533 53.892)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(74.99 -1.104 57.273)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(74.99 -8.276 68.225)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Rectangle_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1660-2",
    width: 54.877,
    height: 78.494,
    fill: "#03002F",
    rx: 7,
    transform: "rotate(86 32.503 69.674)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    width: 43.716,
    height: 26.23,
    fill: "#fff",
    opacity: 0.4,
    rx: 2,
    transform: "rotate(85.99 26.564 70.139)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1663",
    width: 2.953,
    height: 34.973,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(85.99 3.827 58.046)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(85.99 -7.45 52.831)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(85.99 -10.325 55.988)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1665",
    width: 2.953,
    height: 18.361,
    className: "cls-2",
    rx: 1.476,
    transform: "rotate(85.99 -20.83 67.056)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1672",
    fill: "none",
    d: "M0 0H125V125H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanDob);
export default __webpack_public_path__ + "static/media/panDob.217d74ee80315a92c0fd4ccc635d8c93.svg";
export { ForwardRef as ReactComponent };